import http from 'axios'
import urls from './manageRoles.urls'

const transformFeatures = selectedFeatures => {
  const features = []
  const featureSet = {}

  selectedFeatures.forEach(item => {
    if (!featureSet[item]) {
      features.push({ featureId: item, selected: true })
      featureSet[item] = true
    }
  })

  return features
}
export default {
  getRoles: ({ state, rootState, commit }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })

    return http
      .get(urls.getRoles)
      .then(response => {
        commit('setRoles', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  getRoleDetails: ({ state, rootState, commit }, value) => {
    commit('global/setShowLoadingSpinner', true, { root: true })

    const searchCriteria = {
      roleId: value.editedItem.roleId,
      clientId: value.editedItem.clientId
    }

    return http
      .get(urls.roleFeature, { params: searchCriteria })
      .then(response => {
        commit('setRoleDetails', response.data)
        commit('setEditedItemIndex', value.itemIndex)
        commit('setEditedItem', value.editedItem)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  saveRole: ({ state, rootState, commit, dispatch }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })

    const roleRequest = {
      roleName: state.roleDetails.roleName,
      roleDescription: state.roleDetails.roleDescription,
      roleId: state.roleDetails.roleId,
      clientId: parseInt(state.roleDetails.clientId),
      features: transformFeatures(state.selectedFeatures),
      restrictiveFlag: null
    }

    if (state.editedItemIndex !== -1) {
      return http
        .put(urls.roleFeature + '/' + state.editedItem.roleId, roleRequest)
        .then(response => {
          dispatch('getRoles')
          commit('global/setShowLoadingSpinner', false, { root: true })
        }).catch(() => {
          commit('global/setShowLoadingSpinner', false, { root: true })
        })
    } else {
      return http
        .post(urls.roleFeature, roleRequest)
        .then(response => {
          dispatch('getRoles')
          commit('global/setShowLoadingSpinner', false, { root: true })
        }).catch(() => {
          commit('global/setShowLoadingSpinner', false, { root: true })
        })
    }
  }
}
